
import { defineComponent } from "@vue/runtime-core";
import Button from "primevue/button";

export default defineComponent({
  name: "Routeaeroexpress",
  components: {
    Button,
  },
  props: ["info", "schedule"],
  data() {
    return {
      visibleFull: false,
      hoursWords: ["час", "часа", "часов"],
      minutesWords: ["минута", "минуты", "минут"],
      activeOrder: this.$route.params,
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    isDateMoreThanToday(date: any): boolean {
      let today = new Date();
      let routeDate = new Date(date);
      if (today > routeDate) {
        return false;
      } else {
        return true;
      }
    },
    getTimeOfRoute(depDate: any, arrDate: any) {
      let depTime = new Date(depDate);
      let arrTime = new Date(arrDate);
      let diffCount: any = depTime.valueOf() - arrTime.valueOf();
      let finalHours = Math.floor((diffCount % 86400000) / 3600000);
      let finalMinutes = Math.floor(((diffCount % 86400000) % 3600000) / 60000);
      return finalHours + "ч " + finalMinutes + "м в пути";
    },
    getHoursTimeInFlight(time: any) {
      let flightHours = 0;
      let splited = time.split(":");
      flightHours += +splited[0];
      return flightHours;
    },
    getMinutesTimeInFlight(time: any) {
      let flightMinutes = 0;
      let splited = time.split(":");
      flightMinutes += +splited[1];
      return flightMinutes;
    },
    getHoursTransferTime(depTrans: any, arrTrans: any) {
      let depTime = new Date(depTrans);
      let arrTime = new Date(arrTrans);
      let diffCount: any = depTime.valueOf() - arrTime.valueOf();
      let finalHours = Math.floor((diffCount % 86400000) / 3600000);
      let finalMinutes = Math.round(((diffCount % 86400000) % 3600000) / 60000);
      return finalHours + "ч " + finalMinutes + "м";
    },
    declOfHours(number: any, words: any) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
      ];
    },
    hide() {
      this.$emit("update:visible", false);
    },
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()];
    },
    getAnyDate(date: any) {
      let created: any = new Date(date);
      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };
      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes()
      );
    },
    getTime(date: any) {
      let time = new Date(date);
      let hours = time.getHours();
      let minutes = time.getMinutes();
      if (minutes < 10) {
        return hours + ":0" + minutes;
      }
      return hours + ":" + minutes;
    },
    getHours(date: any) {
      let time = date.split(":");
      let hours = time[0];
      return hours;
    },
    getMinutes(date: any) {
      let time = date.split(":");
      let minutes = time[1];
      return minutes;
    },
    getCompanyLogo(company: any) {
      return `"@/assets/images/companies/${company}.svg"`;
    },
  },
});
